import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white py-8 text-sm text-gray-600">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="font-semibold text-gray-900">VSENDS</p>
            <p className="text-xs text-gray-500 mt-1">© 2026 V CAN RESOURCES LIMITED</p>
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            <Link to="/legal/terms" className="hover:text-blue-600 transition-colors">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-blue-600 transition-colors">Privacy</Link>
            <Link to="/legal/cookies" className="hover:text-blue-600 transition-colors">Cookies</Link>
            <Link to="/legal/dpa" className="hover:text-blue-600 transition-colors">DPA</Link>
            <Link to="/legal/anti-spam" className="hover:text-blue-600 transition-colors">Anti-Spam</Link>
            <Link to="/legal/aup" className="hover:text-blue-600 transition-colors">AUP</Link>
            <Link to="/legal/ai-policy" className="hover:text-blue-600 transition-colors">AI Policy</Link>
            <Link to="/legal/refunds" className="hover:text-blue-600 transition-colors">Refunds</Link>
            <Link to="/legal/gdpr" className="hover:text-blue-600 transition-colors">GDPR</Link>
            <Link to="/legal/security" className="hover:text-blue-600 transition-colors">Security</Link>
          </div>
          <div className="text-xs">
            <a href="mailto:support@vsends.com" className="hover:text-blue-600 transition-colors">support@vsends.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
